import ModalContainer from "../../components/uiKits/modal";

const Modal = () => {
  return <ModalContainer />;
};

export default Modal;
